import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import i18n from "i18next";
import Cookies from "js-cookie";
import logo from "../img/logo.svg";

function Header() {
  const location = useLocation();
  const { t } = useTranslation();

  const languages = [
    { value: "en", label: "EN" },
    { value: "ru", label: "RU" },
    { value: "de", label: "DE" },
    { value: "es", label: "ES" },
    { value: "it", label: "IT" },
    { value: "pl", label: "PL" },
  ];

  const storedLang = Cookies.get("i18next");
  const [currentLang, setCurrentLang] = useState(storedLang || "en");

  useEffect(() => {
    if (storedLang && storedLang !== currentLang) {
      setCurrentLang(storedLang);
      i18n.changeLanguage(storedLang);
    }
    document.body.setAttribute("dir", storedLang === "ar" ? "rtl" : "ltr");
  }, [storedLang, currentLang]);

  const handleChangeLang = (selectedLang) => {
    setCurrentLang(selectedLang.value);
    i18n.changeLanguage(selectedLang.value);
    Cookies.set("i18next", selectedLang.value);
  };

  useEffect(() => {
    if (location.pathname === "/consultation") {
      document.body.classList.add("consultation-page");
    } else {
      document.body.classList.remove("consultation-page");
    }
  }, [location.pathname]);

  return (
    <div className="header-container fixed top-0 left-0 w-full z-50 bg-[#FFF]">
      <div className="max-w-[1220px] h-[60px] xl:h-[72px] justify-between mx-auto px-[20px] xl:px-0 flex items-center transition-colors duration-1000">
        <Link to="/">
          <img src={logo} alt="REVACY LTD" className="w-[40px] xl:w-[60px]" />
        </Link>

        <div className="flex items-center gap-[20px]">
          <Link to="/about-us">
            <p className="text-[16px] text-[#000000B2] font-[500] host-grotesk">
              {t("header.1")}
            </p>
          </Link>

          <Link to="/consultation">
            <p className="text-[16px] text-[#000000B2] font-[500] host-grotesk">
              {t("header.2")}
            </p>
          </Link>

          <Dropdown
            options={languages}
            placeholder="EN"
            onChange={handleChangeLang}
            value={languages.find((lang) => lang.value === currentLang)}
          />
        </div>
      </div>
    </div>
  );
}

export default Header;